<template>
<v-row class="im-result" no-gutters>
    <v-col cols="9" md="12">
        <v-row no-gutters>
            <v-col cols="12" md="3">
                <div class="fill-height align-start justify-start px-2">
                    <div class="body-2 font-weight-bold text-truncate">
                        {{ item.name }}
                    </div>
                    <div>
                        {{ item.city }}
                    </div>
                </div>
            </v-col>
            <v-col md="3" class="px-2 text-truncate" v-if="$vuetify.breakpoint.mdAndUp" px-1 style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis; width: 100%">
                {{ item.organization.name }}
            </v-col>
            <v-col md="2" class="px-1" v-if="$vuetify.breakpoint.mdAndUp">
                <div v-if="item.contract.length > 0">
                    <v-row no-gutters>
                        <v-col cols="9" class="font-weight-bold">
                            HLR-00000
                        </v-col>
                        <v-col cols="3">
                            12 %
                        </v-col>
                    </v-row>
                    <div>
                        {{ formatDate(date) }} - {{ formatDate(date) }}
                    </div>
                </div>
                <div class="regular font-weight-bold pl-2" v-else>
                    N/A
                </div>
            </v-col>
            <v-col md="4" class="px-2" v-if="$vuetify.breakpoint.mdAndUp">
                <div class="text-truncate">
                    {{ item.contact.email }}
                </div>
                <div class="text-truncate">
                    {{ item.contact.phone }}
                </div>
            </v-col>
        </v-row>
    </v-col>

    <v-col cols="3" v-if="$vuetify.breakpoint.smAndDown">
        <div class="text-center">
            <div class="regular font-weight-bold">
                {{ item.console_id }}
            </div>
            <div class="regular" v-if="item.status">
                {{ getStatus(item.status) }}
            </div>
            <div class="regular text-truncate" v-if="item.context">
                {{ getContext(item.context) }}
            </div>
            <div v-if="item.test" class="red--text font-weight-bold">
                Test
            </div>
        </div>
    </v-col>
</v-row>
</template>

<script>
import defaults from "../utils/PropDefaults.js";

export default {
    props: {
        item: {
            type: Object,
            default: defaults.hotel_item
        },
    },

    methods: {
        download(url) {
            window.location = url
        },
        formatDate(date) {
            if(!date) return date;
            return this.$moment(String(date))
                .format('D MMM YY');
        },

        getStatus(value) {
            switch (value) {
            case 'registred':
                return 'Inregistrat';
            case 'accepted':
                return 'Accepted';
            case 'suspended':
                return 'Suspendat';
            case 'published':
                return 'Publicat';
            case 'refused_by_us':
                return 'Refuzat de noi';
            case 'refused_by_them':
                return 'Refuzat de ei';
            }
        },
        getContext(value) {
            switch (value) {
            case 'imemento':
                return 'iMemento';
            case 'yieldplanet':
                return 'YieldPlanet';
            case 'pynbooking':
                return 'PynBooking';
            }
        },

        emitClick() {
            this.$emit('click');
        },

    },

}
</script>

<style>

</style>
